import { Box } from '@material-ui/core';
import React, { memo } from 'react';
import isEqual from 'lodash/isEqual';

function Dashboard() {
  return <Box>Dashboard</Box>;
}

export default memo(Dashboard, isEqual);
